<template>
  <div>
    <v-col cols="12">
      <v-row>
        <v-col cols="12" v-if="informText != ''">
          <v-alert type="error">{{ informText }}</v-alert>
        </v-col>
        <v-col cols="2">
          <v-menu
            ref="menu"
            v-model="menu"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            persistent
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="dateSelected"
                label="Select Date"
                readonly
                v-bind="attrs"
                v-on="on"
                outlined
                dense
              ></v-text-field>
            </template>
            <v-date-picker v-model="dateSelected" scrollable></v-date-picker>
            <!-- <v-date-picker v-model="date" @input="menu2 = false"></v-date-picker> -->
          </v-menu>
        </v-col>
        <v-col cols="1">
          <v-btn color="success" @click="loadData">view data</v-btn>
        </v-col>

        <v-col cols="9"></v-col>

        <v-col cols="12" v-if="!loading">
          <v-data-table
            :headers="headers"
            :items="paymentActData"
            class="elevation-1"
            :search="search"
            v-if="listStt.length > 0"
          >
            <template v-slot:top>
              <v-toolbar flat color="white" style="padding-top: 20px">
                <v-row>
                  <v-col cols="2">
                    <v-text-field
                      v-model="search"
                      append-icon="mdi-magnify"
                      label="Search..."
                      single-line
                      hide-details
                      class="shrink mx-4"
                    ></v-text-field>
                  </v-col>
                  <v-divider vertical></v-divider>
                  <v-col cols="2">
                    <v-select
                      :items="listStt"
                      multiple
                      v-model="sttSelected"
                      @change="filterData"
                      label="Status..."
                    ></v-select>
                  </v-col>
                </v-row>
              </v-toolbar>
            </template>

            <template v-slot:item.BM="{ item }">
              <div>{{ item.bm_name }}</div>
              <div>{{ item.bm_id }}</div>
            </template>

            <template v-slot:item.account_name="{ item }">
              <v-row>
                <v-col cols="6" class="pa-0 ma-0">
                  Name: {{ item.account_name }}
                </v-col>
                <v-col cols="6" class="pa-0 ma-0">
                  Payment: {{ item.payment }}
                </v-col>
                <v-col cols="6" class="pa-0 ma-0">
                  ID: {{ item.account_id }}
                </v-col>
                <v-col cols="6" class="pa-0 ma-0">
                  Status:
                  <template v-if="item.status == 'ACTIVE'">
                    <span style="color: green">{{ item.status }}</span>
                  </template>
                  <template v-else>
                    <span style="color: red">{{ item.status }}</span>
                  </template>
                </v-col>
                <v-col cols="6" class="pa-0 ma-0"></v-col>
                <v-col cols="6" class="pa-0 ma-0">
                  Reason:
                  <span style="color: red">{{ item.disable_reason }}</span>
                </v-col>
              </v-row>
            </template>

            <template v-slot:item.payment_note="props">
              <v-edit-dialog
                :return-value.sync="props.item.payment_note"
                @save="save(props.item)"
                @cancel="cancel"
                @open="open"
                @close="close"
                v-if="roles.update_payment_activity"
              >
                <v-icon small>mdi-pencil</v-icon> {{ props.item.payment_note }}
                <template v-slot:input>
                  <v-text-field
                    v-model="props.item.payment_note"
                    label="Edit"
                    single-line
                    counter
                  ></v-text-field>
                </template>
              </v-edit-dialog>
              <template v-else>{{ props.item.payment_note }}</template>
            </template>

            <template v-slot:item.billing_threshold="props">
              <v-edit-dialog
                :return-value.sync="props.item.billing_threshold"
                @save="save(props.item)"
                @cancel="cancel"
                @open="open"
                @close="close"
                v-if="roles.update_payment_activity"
              >
                {{ props.item.billing_threshold }}
                <template v-slot:input>
                  <v-text-field
                    v-model="props.item.billing_threshold"
                    label="Edit"
                    type="number"
                    single-line
                  ></v-text-field>
                </template>
              </v-edit-dialog>
              <template v-else>{{ props.item.billing_threshold }}</template>
            </template>

            <template v-slot:item.payment_status="{ item }">
              <v-checkbox
                v-model="item.payment_status"
                label="Paid"
                @change="save(item)"
                v-if="roles.update_payment_activity"
              ></v-checkbox>
              <template v-else>{{ item.payment_status }}</template>
            </template>
          </v-data-table>

          <v-snackbar v-model="snack" :timeout="3000" :color="snackColor">
            {{ snackText }}

            <template v-slot:action="{ attrs }">
              <v-btn v-bind="attrs" text @click="snack = false"> Close </v-btn>
            </template>
          </v-snackbar>
        </v-col>
        <template v-else>
          <v-col cols="12">
            <img v-bind:src="require('../../assets/loading/loading.gif')" />
          </v-col>
        </template>
      </v-row>
    </v-col>
  </div>
</template>

<script>
import axios from "axios";
//import Vue from "vue";
import moment from "moment-timezone";
import Amplify, { Auth } from "aws-amplify";

Amplify.configure({
  Auth: {
    region: "ap-southeast-1",
    userPoolId: "ap-southeast-1_8vBdk5PAd",
    userPoolWebClientId: "51e572vhkn38k7tuvsdst697b1",
    mandatorySignIn: true,
  },
});

export default {
  name: "PaymentActivitesList",

  components: {},

  data: () => ({
    search: "",
    userId: "",
    listData: [],
    paymentActData: [],
    loading: false,
    dateSelected: "",
    informText: "",
    roles: [],
    menu: false,
    snack: false,
    snackColor: "",
    snackText: "",
    listStt: [],
    sttSelected: [],
    headers: [
      { text: "BM", value: "BM", sortable: false },
      { text: "Account", value: "account_name", sortable: false, width: "30%" },
      { text: "Payment Node", value: "payment_note", sortable: false },
      { text: "Balance", value: "account_balance", sortable: false },
      {
        text: "Billing Threshold",
        value: "billing_threshold",
        sortable: false,
      },
      { text: "Remaining Amount", value: "remaining_amount" },
      { text: "Payment Status", value: "payment_status", sortable: false },
    ],
  }),

  methods: {
    //Edit Data In Table
    async save(item) {
      console.log("item: ", item);
      var currentSession = await this.$root.$refs.App.currentSession(
        "fb-acc-payment-act-dialog"
      );

      if (currentSession.accessToken) {
        if (item.payment_status == true) {
          //console.log("TRUE");
          item.payment_status = "PAID";
        } else {
          //console.log("FALSE");
          item.payment_status = "";
        }
        var data = {
          payment_activity: {
            date: this.dateSelected,
            payment_status: item.payment_status,
            payment_note: item.payment_note,
          },
          billing_threshold: item.billing_threshold,
        };

        //console.log("data: ", data);
        await fetch(
          window.domain + "marketing/fb-ad-accounts/" + item.account_id,
          {
            method: "PUT",
            headers: { Authorization: currentSession.accessToken },
            body: JSON.stringify(data),
          }
        )
          .then((response) => response.json())
          .then((data) => {
            console.log("response: ", data);
          });
      }

      if (item.payment_status == "PAID") {
        item.payment_status = true;
      } else {
        item.payment_status = false;
      }

      item.remaining_amount = item.billing_threshold - item.account_balance;
      this.snack = true;
      this.snackColor = "success";
      this.snackText = "Data saved";
    },
    cancel() {
      this.snack = true;
      this.snackColor = "error";
      this.snackText = "Canceled";
    },
    open() {
      this.snack = true;
      this.snackColor = "info";
      this.snackText = "Dialog opened";
    },
    close() {
      console.log("Dialog closed");
    },

    //Payment Act Data
    async loadData() {
      this.loading = true;
      this.listData = [];
      this.paymentActData = [];
      this.listStt = [];
      this.informText = "";
      var currentSession = await this.$root.$refs.App.currentSession(
        "fb-acc-payment-act-loadData"
      );

      if (currentSession.accessToken) {
        let queryParam = {
          date: this.dateSelected,
        };
        await axios
          .get(window.domain + "marketing/fb-payment-activities?", {
            headers: { Authorization: currentSession.accessToken },
            params: queryParam,
          })
          .then((response) => {
            // console.log(this.AuthStr)
            console.log("response: ", response);
            this.listData = response.data.data;
            //console.log(response.data.error_message);
            if (response.data.error_message != "") {
              this.alert = true;
              this.informText = response.data.error_message;
            }
          })
          .catch((err) => {
            console.log("Err: ", err);
          });
      }
      this.convertData();
      this.loading = false;
    },

    convertData() {
      var sttTemp = new Set();
      for (var i of this.listData) {
        if (i.payment_status == "PAID") {
          i.payment_status = true;
        } else {
          i.payment_status = false;
        }

        this.paymentActData.push(i);
        sttTemp.add(i.status);
      }
      this.listStt = Array.from(sttTemp);
      //console.log("this.paymentActData: ", this.paymentActData);
      //console.log("this.sttTemp: ", this.listStt);
    },

    filterData() {
      this.paymentActData = [];
      if (this.sttSelected.length > 0) {
        for (const o of this.sttSelected) {
          for (var i of this.listData) {
            if (i.status == o) {
              if (i.payment_status == "PAID") {
                i.payment_status = true;
              } else {
                i.payment_status = false;
              }

              this.paymentActData.push(i);
            }
          }
        }
      } else {
        for (i of this.listData) {
          if (i.payment_status == "PAID") {
            i.payment_status = true;
          } else {
            i.payment_status = false;
          }

          this.paymentActData.push(i);
        }
      }
    },
  },

  async mounted() {
    this.roles = await this.$cookies.get("fb_payment_activity");

    try {
      await Auth.currentAuthenticatedUser({ bypassCache: false });
    } catch (error) {
      console.log("User logged out!");
      this.$router.push("/login");
    }

    var currentSession = await this.$root.$refs.App.currentSession(
      "fb-acc-payment-act-mounted"
    );
    //console.log('currentSession: ',currentSession.accessToken)
    if (currentSession.accessToken) {
      this.userId = currentSession.username;
      this.dateSelected = moment(new Date()).format("YYYY-MM-DD");
    }

    if (this.roles.list_payment_activities) {
      console.log("OK");
    } else {
      this.$router.push("/not-authorized");
    }

    //this.loadData();
  },
};
</script>

<style lang="scss" scoped>
</style>